export const TASK_TABS = ['ppv', 'pqv', 'unmatched'] as const;

export type TaskTab = (typeof TASK_TABS)[number];

export const DEFAULT_TASK_TAB: TaskTab = 'ppv';
